<template>
  <el-dialog :visible.sync="show" :fullscreen="true" :show-close="false" custom-class="pcd" append-to-body>
    <div slot="title">
      页面配置<span v-if="page.pageId">&nbsp;:&nbsp;{{page.pageId}} - {{page.name}}</span>
      <el-button size="mini" icon="el-icon-upload" class="pcd-save" @click="toSave" type="primary">保 存</el-button>
      <el-button size="mini" icon="el-icon-circle-close" class="pcd-close" @click="show = false">退 出</el-button>
    </div>
    <design-area ref="designArea" :endpoint="endpoint" :uiId="uiId" group="index-page"></design-area>

    <el-dialog title="保存页面" :visible.sync="showForm" append-to-body>
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="页面名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入页面名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请填写页面描述" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="页面样式" prop="css">
          <el-input v-model="form.css" placeholder="请填写页面样式" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-form-item label="页面创建时" prop="creating">
          <el-input v-model="form.creating" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-form-item label="页面显示" prop="activated">
          <el-input v-model="form.activated" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-form-item label="页面隐藏" prop="deactivated">
          <el-input v-model="form.deactivated" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-form-item label="页面销毁前" prop="destroying">
          <el-input v-model="form.destroying" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-form-item label="页面销毁后" prop="destroyed">
          <el-input v-model="form.destroyed" type="textarea" rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="showForm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doSave(false)">保 存</el-button>
        <el-button size="mini" type="primary" @click="doSave(true)">保存并退出</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import DesignArea from './DesignArea'

export default {
  name: 'page-config-dialog',
  components: {
    DesignArea
  },
  props: {
    uiId: { type: Number, required: true },
    endpoint: { type: String, required: true }
  },
  data () {
    return {
      show: false,
      page: {},
      showForm: false,
      form: { name: '', desc: '', css: '', creating: '', activated: '', deactivated: '', destroying: '', destroyed: '' },
      formRule: {
        name: [{ required: true, message: '请输入页面名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open (page) {
      if (page && !page.clone) {
        this.page = page
      } else {
        this.page = {}
      }
      this.form = { name: this.page.name, desc: this.page.desc, css: '', creating: '', activated: '', deactivated: '', destroying: '', destroyed: '' }
      this.show = true

      this.$nextTick(() => {
        if (page && page.pageId) {
          this.$http.request({
            method: 'get',
            url: `/api/cgPages/${page.pageId}/config`
          }).then((res) => {
            let temp = res.data.data
            this.form.css = temp.css
            this.form.creating = temp.creating
            this.form.activated = temp.activated
            this.form.deactivated = temp.deactivated
            this.form.destroying = temp.destroying
            this.form.destroyed = temp.destroyed
            this.$refs.designArea.init(temp.config)
          })
        } else {
          this.$refs.designArea.init()
          if (this.$refs.form) {
            this.$refs.form.resetFields()
          }
        }
      })
    },
    toSave () {
      if (!this.$refs.designArea.hasConfig()) {
        this.$message.error('请先完成配置')
        return
      }
      this.showForm = true
    },
    doSave (exit) {
      let config = this.$refs.designArea.getConfig()
      if (!config) {
        this.$message.error('请先完成配置')
        return
      }

      this.$refs.form.validate((success) => {
        if (!success) {
          return false
        }

        let data = {
          uiId: this.uiId,
          name: this.form.name,
          config: JSON.stringify(config)
        }
        if (this.form.desc) {
          data.desc = this.form.desc
        }
        if (this.form.css) {
          data.css = this.form.css
        }
        if (this.form.creating) {
          data.creating = this.form.creating
        }
        if (this.form.activated) {
          data.activated = this.form.activated
        }
        if (this.form.deactivated) {
          data.deactivated = this.form.deactivated
        }
        if (this.form.destroying) {
          data.destroying = this.form.destroying
        }
        if (this.form.destroyed) {
          data.destroyed = this.form.destroyed
        }

        let pageId = this.page.pageId
        this.$http.request({
          method: !pageId ? 'post' : 'put',
          url: !pageId ? '/api/cgPages' : `/api/cgPages/${pageId}`,
          data: JSON.stringify(data)
        }).then(() => {
          this.showForm = false
          if (exit) {
            this.show = false
          }
          this.$emit('save')
        })
      })
    }
  }
}
</script>

<style lang='less'>
.pcd{
  .el-dialog__header{
    padding:15px 0;
    border-bottom:1px solid #ebeef5;
    >div{position:relative;text-align:center;height:28px;line-height:28px;}
  }
  .el-dialog__body{padding:0;}
}
.pcd-save{position:absolute;top:0;right:96px;line-height:26px;padding:0 15px;}
.pcd-close{position:absolute;top:0;right:10px;line-height:26px;padding:0 15px;}
</style>
